var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "staff-form",
    attrs: { visible: _vm.showModal, size: "small" },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__header" }, [
              _c("div", { staticClass: "dialog__header--title" }, [
                _c("h2", { staticClass: "my-1" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.isEdition
                          ? _vm.$l10n.__("Modifier le collaborateur")
                          : _vm.$l10n.__("Ajouter un collaborateur")
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "m-0 gray-60 fs-3" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.isEdition
                          ? _vm.$l10n.__("Modifier un membre de votre équipe !")
                          : _vm.$l10n.__(
                              "Ajouter un nouveau membre à votre équipe !"
                            )
                      ) +
                      "\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog__header--close" },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "div",
                { staticClass: "m-auto" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "staffForm",
                      staticClass: "el-form-LH32 flex-row mb-3",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        labelWidth: "150px",
                        labelPosition: "top"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "civility",
                            error: _vm.errors.get("civility")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Civilité")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "wp-4",
                              attrs: { mode: "edit", options: _vm.civilities },
                              model: {
                                value: _vm.form.civility,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "civility", $$v)
                                },
                                expression: "form.civility"
                              }
                            },
                            _vm._l(_vm.civilities, function(civility) {
                              return _c(
                                "el-radio",
                                {
                                  key: civility.label,
                                  attrs: { label: civility.value }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(civility.label) +
                                      "\n                            "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "firstname",
                            error: _vm.errors.get("firstname")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Prénom")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-input", {
                            model: {
                              value: _vm.form.firstname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "firstname", $$v)
                              },
                              expression: "form.firstname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "lastname",
                            error: _vm.errors.get("lastname")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Nom")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-input", {
                            model: {
                              value: _vm.form.lastname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "lastname", $$v)
                              },
                              expression: "form.lastname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "email",
                            error: _vm.errors.get("email")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Email")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: { type: "email" },
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "mobile_number",
                            error: _vm.errors.get("mobile_number")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Portable")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("CompassTelInput", {
                            staticClass: "staff-form__tel-input",
                            attrs: {
                              defaultCountry: "fr",
                              menuClass: "staff-form__tel-input-dropdown"
                            },
                            model: {
                              value: _vm.form.mobile_number,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mobile_number", $$v)
                              },
                              expression: "form.mobile_number"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "phone_number",
                            error: _vm.errors.get("phone_number")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Ligne fixe")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("CompassTelInput", {
                            staticClass: "staff-form__tel-input",
                            attrs: {
                              defaultCountry: "fr",
                              menuClass: "staff-form__tel-input-dropdown"
                            },
                            model: {
                              value: _vm.form.phone_number,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "phone_number", $$v)
                              },
                              expression: "form.phone_number"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isSellsyCorp
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "team",
                                    error: _vm.errors.get("team")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "gray-100" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$l10n.__("Equipe")
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2340520111
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("select-input", {
                                    attrs: {
                                      mode: "edit",
                                      options: _vm.teams,
                                      placeholder: _vm.$t.__(
                                        "common.actions.select"
                                      ),
                                      labelColumn: "name",
                                      idColumn: "id",
                                      appendToBody: true
                                    },
                                    on: { input: _vm.resetJob },
                                    model: {
                                      value: _vm.form.team,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "team", $$v)
                                      },
                                      expression: "form.team"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "job",
                                    error: _vm.errors.get("job")
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "gray-100" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$l10n.__("Poste")
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2546993967
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("select-input", {
                                    attrs: {
                                      mode: "edit",
                                      options: _vm.jobs,
                                      placeholder: _vm.$t.__(
                                        "common.actions.select"
                                      ),
                                      labelColumn: "name",
                                      idColumn: "id",
                                      appendToBody: true
                                    },
                                    model: {
                                      value: _vm.form.job,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "job", $$v)
                                      },
                                      expression: "form.job"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "flex-column separator",
                          attrs: {
                            prop: "profile",
                            error: _vm.errors.get("profile")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.__("Profil de privilèges")
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("select-input", {
                            attrs: {
                              mode: "edit",
                              options: _vm.profiles,
                              placeholder: _vm.$t.__(
                                "forms.StaffForm.select_profil"
                              ),
                              labelColumn: "name",
                              idColumn: "id",
                              appendToBody: true
                            },
                            model: {
                              value: _vm.form.profile,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "profile", $$v)
                              },
                              expression: "form.profile"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "form-item-caption typographies-paragraph-small-regular"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Si vous voulez accorder à votre collaborateur un accès à l’ensemble des fonctionnalités et paramétrages du compte, sélectionnez le profil Administrateur"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("p", { staticClass: "bold pb-2" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Paramétrage Sellsy")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "grey pb-3" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Veuillez choisir le profil de privilèges à associer à ce collaborateur. Vous pouvez créer / modifier des profils de privilèges via la page de gestion des profils utilisateurs"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isEdition
                            ? _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.form.first_connection_onboarding,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "first_connection_onboarding",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.first_connection_onboarding"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Autoriser le collaborateur a modifier ses informations"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasLicenseManagement
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "licenses",
                                label: _vm.$l10n.__("Licence"),
                                error: _vm.errors.get("licenses")
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-row licenses mb-2" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "ml-3 fs-2 semibold link",
                                      attrs: {
                                        href: "https://go.sellsy.com/offres",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Comparer les licences"
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("select-input", {
                                attrs: {
                                  mode: "edit",
                                  options: _vm.availableLicenses,
                                  placeholder: _vm.$t.__(
                                    "forms.StaffForm.select_licence"
                                  ),
                                  labelColumn: "label",
                                  idColumn: "value",
                                  appendToBody: true
                                },
                                model: {
                                  value: _vm.form.licenses[0].id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form.licenses[0], "id", $$v)
                                  },
                                  expression: "form.licenses[0].id"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "timezone",
                            error: _vm.errors.get("timezone")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Fuseau horaire")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("select-input", {
                            attrs: {
                              mode: "edit",
                              filterable: true,
                              idColumn: "value",
                              labelColumn: "name",
                              options: _vm.timezones,
                              appendToBody: true
                            },
                            model: {
                              value: _vm.form.timezone,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "timezone", $$v)
                              },
                              expression: "form.timezone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "language",
                            error: _vm.errors.get("language")
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c("span", { staticClass: "gray-100" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$l10n.__("Langue")) +
                                        "\n                            "
                                    )
                                  ])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("select-input", {
                            attrs: {
                              mode: "edit",
                              options: _vm.languages,
                              appendToBody: true
                            },
                            model: {
                              value: _vm.form.language,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "language", $$v)
                              },
                              expression: "form.language"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.primaryButtonText,
                    type: "primary",
                    loading: _vm.isFormSubmitting
                  },
                  on: {
                    click: function($event) {
                      return _vm.validateAndSubmit("staffForm")
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }